export default "/dist/files/no_task.53f4721b6b5560884ddaa543e2672796.svg";